<template>
	<div>
		<router-view />
		<!-- <HeaderContent />
		<FooterContent /> -->
	</div>
</template>

<script>
	// import HeaderContent from './components/HeaderComponent.vue'
	// import FooterContent from './components/FooterComponent.vue'
	export default {
		name: 'App',
		components: {
			// HeaderContent,
			// FooterContent
		}
	}
</script>

	